import React from 'react';

export const ToolkitContext = React.createContext(null);
